import React, { useEffect, Fragment, useRef } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { validResult, clearResult } from "./DilutionUtils";
import Link from "../Link";

const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    htmlElRef.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
};

function FocusInput(props) {
  const { focus, ...otherProps } = props;
  const [inputFocusRef, setInputFocus] = useFocus();

  useEffect(() => {
    if (focus) {
      setInputFocus();
    }
  }, []);
  return <input {...otherProps} ref={inputFocusRef} />;
}

function DilutionTestInput({
  dilutionTest,
  selected,
  saveDilutionTest,
  setCurrentDilutionTest,
}) {
  // When ND or '> Max Count' is chosen, clear the count
  const handleResultTypeChange = (e) => {
    updateResultType(e.target.value);
  };

  const updateResultType = (value) => {
    setCurrentDilutionTest();
    dilutionTest.result_type = Number(value);
    if (dilutionTest.result_type !== 1) {
      dilutionTest.input_count = "";
    }
  };

  const updateCount = (e) => {
    dilutionTest.input_count = e.target.value;
    dilutionTest.result_type = 1;
    setCurrentDilutionTest();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      saveDilutionTest(dilutionTest);
    }
    if (e.key === "m") {
      updateResultType(3);
      return;
    }
    if (e.key === "n") {
      updateResultType(2);
      return;
    }
    if (e.key === "u") {
      updateResultType(4);
      return;
    }
    // if (e.key === "t") {
    //   updateResultType(5);
    //   return;
    // }
    if (e.key === "x") {
      clearResult(dilutionTest);
      return;
    }
  };

  let placeholder = /(\(-\d+\))/.exec(dilutionTest.test_name);
  if (placeholder) {
    placeholder = placeholder[0];
  }

  return (
    <tr className={classNames({ selected: true })}>
      <td>{dilutionTest.label_information && dilutionTest.label_information.join(", ")}</td>
      <td>{dilutionTest.test_name}</td>
      <td className="nowrap">
        {dilutionTest.qualifier ? (
          <span>
            {dilutionTest.qualifier} {dilutionTest.result_value}
          </span>
        ) : (
          <Fragment>
            <FocusInput
              size={10}
              placeholder={placeholder}
              onKeyPress={handleKeyPress}
              value={String(dilutionTest.input_count)}
              type="number"
              onFocus={setCurrentDilutionTest}
              onChange={updateCount}
              focus={selected}
            />
            &nbsp;&nbsp;&nbsp;
            <Option
              label={"N.D."}
              value={2}
              dilutionTest={dilutionTest}
              onChange={handleResultTypeChange}
            />
            <Option
              label={"> Max Count"}
              value={3}
              dilutionTest={dilutionTest}
              onChange={handleResultTypeChange}
            />
            <Option
              label="Unreportable"
              value={4}
              dilutionTest={dilutionTest}
              onChange={handleResultTypeChange}
            />
            <Option
              label="Presumptive"
              value={6}
              dilutionTest={dilutionTest}
              onChange={handleResultTypeChange}
            />
            <Link
              onClick={() => clearResult(dilutionTest)}
              style={{
                marginRight: 5,
                marginLeft: 5,
                opacity: validResult(dilutionTest) ? 1.0 : 0.2,
              }}
            >
              <i className="fa fa-times" />
            </Link>
            {/* <Option
              label="Tech Review"
              value={5}
              dilutionTest={dilutionTest}
              onChange={handleResultTypeChange}
            /> */}
          </Fragment>
        )}
      </td>
    </tr>
  );
}

function Option({ label, onChange, dilutionTest, value }) {
  return (
    <label
      className={classNames("result_type", "result_type_" + value, {
        selected: dilutionTest.result_type === value,
      })}
    >
      <input
        type="radio"
        onChange={onChange}
        value={value}
        checked={dilutionTest.result_type === value}
      />
      {label}
    </label>
  );
}

Option = observer(Option);
export default observer(DilutionTestInput);
